module.exports = __webpack_public_path__ + "static/media/zw.58e2cbd6.svg";